import React from 'react';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import PbxSettings from './PbxSettings';
import HelpButton from '../../../../components/HelpButton';

const PbxPhoneQueuesList = React.lazy(() => import('./PbxPhoneQueuesList'));

const PbxPhoneQueuesPage = (props) => (
  <PbxSettings scrolling>
    <div className="text-right">
      <HelpButton fileName="pbx-settings-queues" />
    </div>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <PbxPhoneQueuesList {...props} />
      </React.Suspense>
    </ErrorBoundary>
  </PbxSettings>
);

export default PbxPhoneQueuesPage;
